import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./scss/index.scss";
import React, { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import ReactSVG from "react-svg";
import { Button, Overlay } from "../..";
import NoPhoto from "../../../images/no-photo.svg";
import removeWishlist from "../../../images/remove-wishlist.svg";
import closeImg from "../../../images/x.svg";
import { commonMessages } from "../../../intl";
export function RemoveWishlistItem(_ref) {
  var overlay = _ref.overlay;
  var intl = useIntl();
  var _overlay$context$data = overlay.context.data,
      productImage = _overlay$context$data.productImage,
      remove = _overlay$context$data.remove;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var handleRemove = useCallback(
  /*#__PURE__*/
  _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setLoading(true);
            _context.next = 3;
            return remove();

          case 3:
            setLoading(false);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [remove]);
  return React.createElement(Overlay, {
    context: overlay
  }, React.createElement("div", {
    className: "remove-wishlist-item-modal"
  }, React.createElement(ReactSVG, {
    path: closeImg,
    onClick: overlay.hide,
    className: "remove-wishlist-item-modal__close-icon"
  }), React.createElement("img", {
    src: removeWishlist,
    className: "remove-wishlist-item-modal__image",
    alt: "icon"
  }), React.createElement("h4", {
    className: "remove-wishlist-item-modal__title"
  }, intl.formatMessage(_defineProperty({
    defaultMessage: "Maybe it's that bad... Are you sure you want to remove your design ?",
    "id": "components.OverlayManager.RemoveWishlistItem.RemoveWishlistItem.3416343656"
  }, "id", "components.OverlayManager.RemoveWishlistItem.RemoveWishlistItem.3416343656"))), React.createElement("div", {
    className: "remove-wishlist-item-modal__product-image"
  }, React.createElement("img", {
    src: productImage || NoPhoto,
    alt: "icon"
  })), React.createElement("div", {
    className: "remove-wishlist-item-modal__buttons"
  }, React.createElement(Button, {
    className: "cancel",
    onClick: overlay.hide
  }, intl.formatMessage(commonMessages.cancel)), React.createElement(Button, {
    className: "red",
    onClick: handleRemove,
    disabled: loading
  }, intl.formatMessage(commonMessages.delete)))));
}